import { useTranslation } from 'react-i18next'

import Button from '../../../../components/tailwind/Button'
import Modal from '../../../../components/tailwind/Modal'
import { Heading } from '../../../../components/ui/Heading'
import { usePartnerContext } from '../../../../context'
import {
  LIFE_CYCLE_STAGES,
  useLifecycleStageTracking
} from '../../../../hooks/useLifecycleStageTracking'

export default function CompletionModal({ open, setOpen }) {
  const { t } = useTranslation()
  const { partner } = usePartnerContext()
  const { trackLifecycleStage } = useLifecycleStageTracking()

  const handleComplete = () => {
    // Sync „Onboarding fertig" → Form-Record → Lambda → HubSpot + Partner
    // (handleFunnelLeadOnboardingComplete reagiert auf den lifecycle_stage-
    //  Übergang nach ONBOARDING_COMPLETED). Nur wenn aivy_form_id vorhanden —
    //  ältere User ohne Funnel-Origin überspringen wir stillschweigend.
    if (partner?.aivy_form_id) {
      trackLifecycleStage({
        aivy_form_id: partner.aivy_form_id,
        lifecycle_stage: LIFE_CYCLE_STAGES.ONBOARDING_COMPLETED,
        lifecycle_stage_before: LIFE_CYCLE_STAGES.ONBOARDING_STARTED,
        lead_progress: 100,
        partner_id: partner.id
      })
    }
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      borderRadius='rounded-xl'
      size='xl'
      hideCloseButton
    >
      <Heading level={2} className={'text-center'}>
        {t('discover.assistant.onboarding.completion.title')}
      </Heading>
      <div className='mt-4'>
        <p className='text-center text-sm text-rockGrey'>
          {t('discover.assistant.onboarding.completion.description')}
        </p>
      </div>
      <div className='mt-12 flex items-center justify-center'>
        <Button.PrimaryLG
          text={t('discover.assistant.onboarding.completion.cta')}
          onClick={handleComplete}
        />
      </div>
    </Modal>
  )
}
